import { selectSliceCisview } from '../../selectors/HELPERS';
import { ROOT_SLICE } from './constants';
import { getTimeuuid, toTimeuuids } from './util';

/**
 * SLICES
 */
export const selectRootSlice = state => {
	const appSlice = selectSliceCisview(state);
	return appSlice[ROOT_SLICE] || state;
};

export const selectSurveyGuidMaps = state => {
	const slice = selectRootSlice(state);
	return slice.surveyGuidMaps;
}

/**
 * BASE
 */

export const selectMapIsSyncing = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isSyncing;
}

export const selectMapIsUnsyncing = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isUnsyncing;
}

export const selectMapIsDeleting = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isDeleting;
}

export const selectMapIsDeleted = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isDeleted;
}

export const selectMapIsQueuedForDelete = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isQueuedForDelete;
}

export const selectMapIsSelected = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.isSelected;
}

export const selectMapErrorMessages = state => {
	const maps = selectSurveyGuidMaps(state);
	return maps.errorMessages;
}

/**
 * MAIN
 */

export const selectIsSyncing = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsSyncing(state);
	return _map[timeuuid];
}

export const selectIsUnsyncing = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsUnsyncing(state);
	return _map[timeuuid];
}

export const selectIsDeleting = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsDeleting(state);
	return _map[timeuuid];
}

export const selectIsDeleted = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsDeleted(state);
	return _map[timeuuid];
}

export const selectIsQueuedForDelete = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsQueuedForDelete(state);
	return _map[timeuuid];
}

export const selectShowDeleteConfirmationModal = (state, surveys = []) => {
	return surveys.some(s => selectIsQueuedForDelete(state, s));
}

export const selectIsBusy = (state, survey) => {
	return selectIsSyncing(state, survey) 
		|| selectIsUnsyncing(state, survey)
		|| selectIsDeleting(state, survey);
}

export const selectIsSelected = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsSelected(state);
	return _map[timeuuid];
}

export const selectIsSomeSelected = (state, surveys = []) => {
	const timeuuids = toTimeuuids(surveys);
	return timeuuids.some(id => selectIsSelected(state, id));
}

export const selectIsEverySelected  = (state, surveys = []) => {
	const timeuuids = toTimeuuids(surveys);
	return timeuuids.every(id => selectIsSelected(state, id));
}
export const selectHasError = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsDeleting(state);
	return !!_map[timeuuid];
}

export const selectErrorMessage = (state, survey) => {
	const timeuuid = getTimeuuid(survey);
	const _map = selectMapIsDeleting(state);
	return _map[timeuuid];
}

const selectAutoFixStore = (state) => {
	const slice = selectRootSlice(state);
	return slice.autoFixStore;
}

export const selectAutoFixStoreMap = (state) => {
	return selectAutoFixStore(state)._map;
}

export const selectAutoFixStoreList = (state) => {
	return selectAutoFixStore(state)._list;
}

export const selectAutoFixIsFixing = (state) => {
	return selectAutoFixStore(state).isFixing;
}

export const selectAutoFixIsStopping = (state) => {
	return selectAutoFixStore(state).isStopping;
}

export const selectJobListTab = (state) => {
	const slice = selectRootSlice(state);
	return slice.jobListCache?.jobListTab;
}

export const selectFJobs = (state) => {
	const slice = selectRootSlice(state);
	return slice.jobListCache?.fjobs;
}

export const selectSJobs = (state) => {
	const slice = selectRootSlice(state);
	return slice.jobListCache?.sjobs;
}


export default {
	selectRootSlice,
	selectSurveyGuidMaps,

	selectMapIsSyncing,
	selectMapIsUnsyncing,
	selectMapIsDeleting,
	selectMapIsDeleted,
	selectMapIsQueuedForDelete,
	selectMapIsSelected,
	selectMapErrorMessages,

	selectIsSyncing,
	selectIsUnsyncing,
	selectIsDeleting,
	selectIsDeleted,
	selectIsQueuedForDelete,
	selectShowDeleteConfirmationModal,
	selectIsSelected,
	selectIsSomeSelected,
	selectIsEverySelected,
	selectHasError,
	selectErrorMessage,

	selectJobListTab,
	selectFJobs,
	selectSJobs,

	selectAutoFixStoreMap,
	selectAutoFixStoreList,
	selectAutoFixIsFixing,
	selectAutoFixIsStopping,
};
